import React from 'react';
import cn from 'classnames';

import type { DsTextColor } from './typographyTextColor';
import { dsTextColorClassMap } from './typographyTextColor';

export interface TextProps {
  size?: 'l' | 'default' | 's';
  weight?: 'regular' | 'semibold' | 'bold' | 'medium';
  color?: DsTextColor;
  children: React.ReactNode;
  as?: React.ElementType;
  className?: string;
  htmlFor?: string;
}

export const Text: React.FC<TextProps> = ({
  size = 'default',
  weight = 'regular',
  color = 'primary',
  children,
  as: Component = 'p',
  className,
  htmlFor,
}) => {
  const classes = cn(
    dsTextColorClassMap[color],
    {
      'text-ds-text-l': size === 'l',
      'text-ds-text': size === 'default',
      'text-ds-text-s': size === 's',
      'font-normal': weight === 'regular',
      'font-semibold': weight === 'semibold',
      'font-bold': weight === 'bold',
      'font-medium': weight === 'medium',
    },
    className,
  );

  return (
    <Component className={classes} htmlFor={htmlFor}>
      {children}
    </Component>
  );
};

export default Text;
